// ReminderModal.tsx
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  CircularProgress,
  IconButton,
  Modal,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import AppErrorMessage from "../../common/AppErrorMessage";
import HiddenModelIcon from "../../IconComp/hiddenModelIcon";
import CloseIcon from "@mui/icons-material/Close";

interface ReminderModalProps {
  open: boolean;
  onClose: () => void;
  onContinue: () => void;
}

const ReminderModal = ({ open, onClose, onContinue }: ReminderModalProps) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          width: {
            xs: "310px", // for screens <600px
            sm: "544px", // for screens ≥600px
          },
          bgcolor: "background.paper",
          borderRadius: "12px",
          boxShadow: 24,
          p: 0,
          outline: "none",
          mx: "auto",
          mt: "40vh",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            px: 1,
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              p: 2,
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "row", gap: "6px" }}>
              <WarningAmberIcon color="warning" />
              <Box sx={{ fontSize: "20px", fontWeight: 600, mt: "-2px" }}>
                Confirm Restock Batch
              </Box>
            </Box>
          </Box>
          <Box sx={{ mt: "-10px" }}>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>

        {/* Body */}
        <Box
          sx={{ px: 3, fontSize: "16px", fontWeight: 400, color: "#535862" }}
        >
          You are about to restock an existing batch of this product. If the
          Batch Number, Expiry Date, Cost Price, and Sell Price match an
          existing batch exactly, then the entered quantity will be added to
          that batch, and all other details will remain unchanged.
        </Box>

        {/* Footer */}
        <DialogActions
          sx={{ mt: "10px", justifyContent: "flex-end", padding: 2 }}
        >
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              fontSize: "16px",
              borderRadius: "8px",
              px: 3,
              color: "#414651",
              borderColor: "#BDBDBD",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onContinue}
            sx={{
              ml: 2,
              textTransform: "none",
              fontWeight: 600,
              fontSize: "16px",
              borderRadius: "8px",
              px: 3,
              backgroundColor: "#0055A9",
              "&:hover": {
                backgroundColor: "#0055A5",
              },
            }}
          >
            Continue
          </Button>
        </DialogActions>
      </Box>
    </Modal>
  );
};

export default ReminderModal;
